import { BrazeContentCard } from "@tvg/braze/src/types";
import { CARD_SC } from "../../types";

export const filterBrazeCards = (brazeContentCards: BrazeContentCard[]) =>
  brazeContentCards.filter((card) => card.sc !== CARD_SC.CONTROL_CARD);

export const getNonViewedCards = (
  listOfBrazeCards: BrazeContentCard[]
): BrazeContentCard[] => listOfBrazeCards.filter((card) => !card.viewed);
